import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormOctagon: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconFormOctagon"><Path d="M15.1064 2C15.7695 2 16.4052 2.26363 16.874 2.73242L21.2676 7.12598C21.7364 7.59481 22 8.23055 22 8.89355V15.1064C22 15.7694 21.7364 16.4052 21.2676 16.874L16.874 21.2676C16.4052 21.7364 15.7694 22 15.1064 22H8.89355C8.23055 22 7.59481 21.7364 7.12598 21.2676L2.73242 16.874C2.26363 16.4052 2 15.7695 2 15.1064V8.89355C2 8.23055 2.26363 7.59481 2.73242 7.12598L7.12598 2.73242C7.59481 2.26363 8.23055 2 8.89355 2H15.1064Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFormOctagon;
